@if (!!link || !!button) {
  <div class="h-100 change__wrapper" wlCSCapture>
    @if (!!link) {
      <a
        class="change__link change__link--md btn btn-sm btn-outline-secondary"
        [wlAutomationId]="automationId"
        [wlTrackLink]="link?.value?.text"
        [trackLinkInfo]="{
          rendering: rendering,
          field: link?.value,
        }"
        *wlGenericLink="link; extras: extras"
      ></a>
      <a
        class="change__link change__link--sm btn btn-icon btn-outline-secondary"
        [wlAutomationId]="automationId"
        [wlTrackLink]="link?.value?.text"
        [trackLinkInfo]="{
          rendering: rendering,
          field: link?.value,
        }"
        *wlGenericLink="link; extras: extras"
      >
        <fa-icon icon="pen"></fa-icon>
      </a>
    } @else {
      <button
        class="change__link change__link--md btn btn-sm btn-outline-secondary"
        [wlAutomationId]="automationId"
        [wlTrackLink]="button"
        [trackLinkInfo]="{
          rendering: rendering,
          field: button,
        }"
        (click)="clickChange.emit()"
      >
        {{ button }}
      </button>
      <button
        class="change__link change__link--sm btn btn-icon btn-outline-secondary"
        [wlAutomationId]="automationId"
        [wlTrackLink]="button"
        [trackLinkInfo]="{
          rendering: rendering,
          field: button,
        }"
        (click)="clickChange.emit()"
      >
        <fa-icon icon="pen"></fa-icon>
      </button>
    }
  </div>
}
